const NotificationList = (state = [], action) => {
  switch (action.type) {
    case "NOTIF_LIST":
      return action.payload.data;
    default:
      return state;
  }
};
export { NotificationList };
